export const setLanguage = language => {
  //Persists in localStorage
  localStorage.setItem("locale", language);
  return {
    type: "SET_LANGUAGE",
    payload: language
  };
};
